<template>
<div>
    <header>
        <img src="@/assets/img/BGS04.png" alt />
        <div id="container">
            <div class="row">
                <a :href="month" target="_blank">日直條圖</a>
                <a :href="year" target="_blank">月直條圖</a>
            </div>
            <div class="row">
                <div id="second">
                    <div class="message" id="history">
                        <span id="historyKwh" v-if="history">歷史新高：{{}} kwh</span>
                        <span id="historyDate" v-if="history">{{}}</span>
                    </div>
                    <div class="message" id="info">
                        <span id="infoTotalWatt" class="ulogo">{{ capacity }} KW</span>
                        <span id="infoName" class="ulogo">{{ location }}</span>
                        <span class="ulogo">太陽能光電監控系統</span>
                        <span id="infoDate" class="dlogo">掛錶日：{{ date }}</span>
                        <span id="infoPrice" class="dlogo">單價： {{ price }} (元/度)</span>
                    </div>
                    <div class="message" id="maxWatt" v-if="max">
                        今日高峰：{{ max.watt_dc / 1000 }} kw -
                        {{ max.created_at.substring(11, 16) }}
                    </div>
                    <div class="message" id="maxWatt" v-else></div>
                    <div class="message" id="days">累積天數: {{ days }} 天</div>
                    <div class="message" id="time">{{ getTime() }}</div>
                </div>
            </div>
            <div class="row">
                <div id="third">
                    <div id="chart"></div>
                    <div></div>
                    <div id="value">
                        <div class="value" id="inv" v-if="record">
                            即時發電量： {{ wattDc | formatNumber }} kw
                        </div>
                        <div class="value" id="inv" v-else>
                            即時發電量： {{ 0 | formatNumber }} kw
                        </div>
                        <div class="value" id="co2" v-if="record">
                            累積減碳量： {{ co2 | formatNumber }} kg
                        </div>
                        <div class="value" id="co2" v-else>
                            累積減碳量： {{ 0 | formatNumber }} kg
                        </div>
                        <div class="value" id="kwh" v-if="record">今日度數： {{ today }} 度</div>
                        <div class="value" id="kwh" v-else>今日度數： {{ 0 }} 度</div>
                        <div class="value">
                            <img src="@/assets/img/coinstack.gif" heigh="20px" width="20px" />
                            <span id="money" v-if="record">今日收入： {{ money | formatMoney }} 元</span>
                            <span id="money" v-else>今日收入： {{ 0 | formatMoney }} 元</span>
                        </div>
                        <div class="value" id="totalKwh" v-if="record">累積度數： {{ total }} 度</div>
                        <div class="value" id="totalKwh" v-else>累積度數： {{ 0 }} 度</div>
                        <div class="value">
                            <img src="@/assets/img/money.png" heigh="20px" width="20px" />
                            <span id="totalMoney" v-if="record">累積收入：{{ totalMoney | formatMoney }} 元</span>
                            <span id="totalMoney" v-else>累積收入：{{ 0 | formatMoney }} 元</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div id="fourth"></div>
            </div>
        </div>
        <img src="@/assets/img/BGS01.png" alt />
    </header>
    <img id="footer-top" src="@/assets/img/BGS02.png" alt />
    <footer>
        ® XINYU 信宇開發
        <a href="http://www.xinyu2008.com.tw" target="_blank">監控系統</a>
    </footer>
    <span id="status"></span>
</div>
</template>

<script>
import moment from "moment";
import {
    apiInfo
} from "@/assets/js/api";

export default {
    name: "Mix",
    data() {
        return {
            capacity: 0,
            location: "",
            date: "",
            price: 0,
            days: 0,
            max: 0,
            history: 0,
            record: "",
            correct: 0,
            month: "",
            year: "",
        };
    },
    mounted() {
        let interval = process.env.VUE_APP_INTERVAL;
        let id = this.$route.params.id;

        this.month = "https://solars.hcge.com.tw/bar/month/" + id;
        this.year = "https://solars.hcge.com.tw/bar/year/" + id;
        this.getApiInfo(id);

        setInterval(() => {
            this.getApiInfo(id);
        }, interval);
    },
    beforeUpdate() {},
    methods: {
        getApiInfo(id) {
            let my = this;
            apiInfo(id).then((res) => {
                let rs = res.data;
                let info = rs.info;
                let status = rs.status;
                my.record = rs.record;

                this.capacity = info.capacity;
                this.location = info.location.location.substring(0, 2) + info.name;
                this.date = info.date;
                this.price = info.price;
                this.days = status.days;
                this.correct = rs.corrected_value;
            });
        },
        getTime() {
            return moment().format("YYYY-MM-DD H:m");
        },
    },
    computed: {
        wattDc() {
            return this.record.watt_dc / 1000;
        },
        today() {
            return this.record.today / 1000;
        },
        total() {
            return this.record.total + this.correct;
        },
        co2() {
            return this.total * 0.636;
        },
        money() {
            return this.today * this.price;
        },
        totalMoney() {
            return this.total * this.price;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/main.scss";
</style>
